// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"4402db32","99":"17d9ab96","144":"36c2d773","291":"627dbd74","365":"638f4a15","455":"27c28111","622":"621c9899","632":"ba177394","783":"e4170d3d"}[chunkId] + ".chunk.js";
};